module.exports = __webpack_public_path__ + "img/79.a8951432.jpg";